import React, { useEffect, useState } from "react";
import {Table, Row, Col, Card, CardBody, Modal, CardTitle, ModalHeader, ModalBody, FormGroup, Label, InputGroup, Button} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as url from "../../helpers/url_helper"
import moment from "moment";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { PhoneInput } from 'react-international-phone';
import { json, Link } from "react-router-dom";
const Zones = () => {
  document.title = "AMAVIE | Gestion de la tarification";
  const [zones, setZones]= useState([])
  const removeBodyCss = () => { document.body.classList.add("no_padding"); };
  const loadZone=()=> {
      fetch(`${url.BACKEND_URL}/zones`, {
        method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => { 
        if (responseJson.status==200) { setZones(responseJson.data) } else { setZones([]) }
      }) .catch((error) => {  });
    };
  useEffect(()=>{ loadZone() }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="AMAVIE" title="Zones" />
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <div className="table-responsive">
                    <Table className="table mb-0" style={{fontSize: 16}}>
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Zone</th>
                          <th>Nombre de pays</th>
                          {/* <th>Détails</th> */}
                        </tr>
                      </thead>
                      <tbody>
                         {zones.map((item, key)=>(
                            <tr>
                              <td>{item?.id}</td>
                              <td>{item?.name}</td>
                              <td>{(item?.countries).length}</td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Zones;
